import { useState } from 'react'

export type ActionHandler<T> = (value: T) => void
export type RegisterActionHandler<T> = (handler: ActionHandler<T>) => void
export type OnAction<T> = (value: T) => void

function useActionHandlers<T>(): [RegisterActionHandler<T>, OnAction<T>, Array<ActionHandler<T>>] {
  const [handlers, setHandlers] = useState<Array<ActionHandler<T>>>([])

  const addHandler = (handler: ActionHandler<T>) => {
    setHandlers([...handlers, handler])
  }

  const onAction = (value: T) => {
    for (const handler of handlers) {
      handler(value)
    }
  }

  return [addHandler, onAction, handlers]
}

export default useActionHandlers
